module.exports = "/fonts/bitter-v16-latin-ext-500.ca16f98a67a1843ec8cb46891223e4c2.woff";